import { CREATE_PLAYLIST_URL_FRAGMENT, MY_PLAYLISTS_URL_FRAGMENT, PAGE_NAMES, WATCH_LATER_URL_FRAGMENT } from '../../constants/Navigation';
export const NAVBAR_ITEMS = [PAGE_NAMES.CATALOG, PAGE_NAMES.MY_LEARNING, PAGE_NAMES.SAVED_ITEMS, PAGE_NAMES.PLAYLISTS, PAGE_NAMES.CREATE_PLAYLIST, PAGE_NAMES.TEAM, PAGE_NAMES.PARTNER];
export const NAVBAR_ITEM_URLS = {
  [PAGE_NAMES.CATALOG]: '/',
  [PAGE_NAMES.MY_LEARNING]: '/mylearning/in-progress',
  [PAGE_NAMES.SAVED_ITEMS]: WATCH_LATER_URL_FRAGMENT,
  [PAGE_NAMES.PLAYLISTS]: MY_PLAYLISTS_URL_FRAGMENT,
  [PAGE_NAMES.CREATE_PLAYLIST]: CREATE_PLAYLIST_URL_FRAGMENT,
  [PAGE_NAMES.TEAM]: '/team',
  [PAGE_NAMES.PARTNER]: '/partners'
};